import { Button } from "@omni/ui/components/Button/button.component";
import { useMapped } from "@omni/utils/context/mapped.context";
import { cn } from "@omni/utils/styles";

import { usePaintConfiguratorContext } from "@/components/PaintConfigurator/context/paintConfigurator.context";

import { useFinishesContext } from "../context/finishes.context";

const Finish = () => {
    const { finishes } = useFinishesContext();
    const { setSelectedFinish, nextStep } = usePaintConfiguratorContext();
    const { index } = useMapped();
    const finish = finishes.at(index);

    if (!finish) return null;

    return (
        <Button
            className={cn(
                "tw:group tw:p-0 tw:ring-1 tw:overflow-hidden tw:ring-gray-300 tw:hover:ring-offset-2 tw:hover:scale-[1.01] tw:transition-all"
            )}
            color="transparent"
            onClick={() => {
                setSelectedFinish(finish.value);
                nextStep();
            }}
        >
            <div
                className={cn(
                    "tw:p-3 tw:align-middle tw:bg-background tw:text-grey-dark tw:text-sm"
                )}
            >
                <p className={cn("tw:m-0!")}>{finish.value}</p>
            </div>
        </Button>
    );
};

export { Finish };
